import { h as t } from "vue";
import { g as i } from "./DefaultValues-DOBkctU1.js";
const h = (r, { attrs: e }) => {
  r = { ...i(), ...r };
  const { width: n, height: o } = r;
  return t(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 19.674 19.674",
      width: `${n}`,
      height: `${o}`,
      class: r.class ?? "",
      "aria-hidden": e["aria-hidden"] ?? "true"
    },
    t(
      "g",
      {
        transform: "translate(0.5 -0.329)"
      },
      [
        t("g", {
          transform: "translate(0.5 -0.329)"
        }),
        [
          t("rect", {
            width: "6.938",
            height: "6.938",
            rx: "1.6",
            transform: "translate(0 1.437)",
            fill: "none",
            stroke: "#222",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "1.3"
          }),
          t("rect", {
            width: "6.938",
            height: "6.938",
            rx: "1.6",
            transform: "translate(0 11.167)",
            fill: "none",
            stroke: "#222",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "1.3"
          }),
          t("rect", {
            width: "6.938",
            height: "6.938",
            rx: "1.6",
            transform: "translate(9.73 11.167)",
            fill: "none",
            stroke: "#222",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "1.3"
          }),
          t("rect", {
            width: "6.939",
            height: "6.939",
            rx: "1.6",
            transform: "translate(8.292 4.906) rotate(-45)",
            fill: "none",
            stroke: "#222",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "1.3"
          })
        ]
      ]
    )
  );
};
export {
  h as PartnershipIcon
};
